<template>
    <div class="home">
        <div class="home_center">
            <div class="index_top">
                <div class="swiper">
                    <div class="swiper-wrapper">
                        <div class="swiper-slide" v-for="(item,index) in swiperSlideAll" :key="index">
                            <img :src="item.img" alt="">
                        </div>
                        <!--<div class="swiper-slide"></div>
                        <div class="swiper-slide"></div>-->
                    </div>
                    <div class="swiper-button-prev" @click="swipePrev"></div>
                    <div class="swiper-button-next" @click="swipeNext"></div>
                </div>
            </div>
            <div class="index_first">
                <div class="index_first_top">
                    <div class="left"></div>
                    <div class="center"><div>关于我们</div><div class="YINWEN">ABOUT US</div></div>
                    <div class="right"></div>
                </div>
                <div class="index_first_bottom">
                    <div class="index_first_bottom_left">
                        <div class="letter">逍遥推手结合与时俱进的商业模式与市场需求的时代改变，打造了聚合支付3.0平台，以创新支付产品、多品牌资源整合的互联网+营销新模式，金融产品服务选代升级为平台业务核心，实现支付行业公平、透明、安全、共赢。</div>
                        <div class="letter"></div>
                        <div class="letter">十年行业沉淀，我们已经取得了优秀的市场资源并准备在未来的十年内推动100家战略运营平台 —— <span>推手之家</span>成功上市，做到平台员工以及合作伙伴人人持股、人人轻产、人人致富。</div>
                    </div>
                    <div class="index_first_bottom_right">2</div>
                </div>
            </div>
            <div class="index_sec">
                <div class="index_sec_o">
                    <div class="nian">2011<span>年</span></div>
                    <div class="line"></div>
                    <div class="source">公司源起于2011</div>
                </div>
                <div class="index_sec_line"></div>
                <div class="index_sec_o index_sec_t">
                    <div class="nian">2019<span>年</span></div>
                    <div class="line"></div>
                    <div class="source">逍遥推手孵化</div>
                </div>
                <div class="index_sec_line"></div>
                <div class="index_sec_o">
                    <div class="nian">2020<span>年</span></div>
                    <div class="line"></div>
                    <div class="source">实现独立运营</div>
                </div>
                <div class="index_sec_line"></div>
                <div class="index_sec_o">
                    <div class="nian">2023<span>年</span></div>
                    <div class="line"></div>
                    <div class="source">新的一年尽情期待</div>
                </div>
            </div>
            <div class="index_thi">
                <div class="index_first_top">
                    <div class="left"></div>
                    <div class="center"><div></div><div class="YINWEN">NEWS  INFORMATION</div></div>
                    <div class="right"></div>
                </div>
                <div class="index_thi_bottom">
                    <div class="index_thi_bottom_left"></div>
                    <div class="index_thi_bottom_right">
                        <div class="top" @click="jumpCompany('message')">
                            <div class="one">致所以合作伙伴的一封信</div>
                            <div class="two">各位尊敬的合作伙伴：大家好，我是逍遥推手CEO 王爱军......</div>
                            <div class="three">2022—11—05</div>
                        </div>
                        <div class="top bottom" @click="jumpCompany('notice')">
                            <div class="one">金控—金逍遥重磅上线</div>
                            <div class="two">各位合作伙伴：逍遥推手又迎来一个重大好消息， 金逍遥来啦......</div>
                            <div class="three">2022—10—31</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="index_four">
                <div class="index_first_top">
                    <div class="left"></div>
                    <div class="center"><div>合作88机构</div><div class="YINWEN">COOPERATIVE INSTITUTIONS</div></div>
                    <div class="right"></div>
                </div>
                <div class="index_four_bottom"></div>
            </div>
        </div>
    </div>
</template>

<script>
    import Swiper from 'swiper'
    export default {
        data(){
            return{
                mySwiper:null,
                swiperSlideAll:[
                    {
                        img:require('./img/ju2.png')
                    },
                    {
                        img:require('./img/ju1.png')
                    },
                ]
            }
        },
        mounted(){
            this.mySwiper = new Swiper(".swiper", {
                autoplay : 2500,
                speed:800,
                slidesPerView : 'auto',
                touchRatio : 1,
                swipeToPrev : false,
                swipeToNext : false,
                loopedSlides: 2,
                loop: true,
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                },
            });
        },
        computed: {},
        methods:{
            jumpPage(type){
                if (type == 'about'){
                    this.$router.push({
                        path:'/about'
                    })
                }
                if (type == 'introduce'){
                    console.log("---about",);
                    this.$router.push({
                        path:'/introduce'
                    })
                }
                if (type == 'notice'){
                    this.$router.push({
                        "path":"/newStatus"
                    });
                }
            },
            linkJump(){
                window.location.href = "https://beian.miit.gov.cn/#/Integrated/index"
            },
            swipePrev(){
                this.mySwiper.slidePrev();
                console.log("-----mySwiper",this.mySwiper)
            },
            swipeNext(){
                this.mySwiper.slideNext();
            },
            jumpCompany(type){
                if (type == 'message'){
                    this.$router.push({
                        path:'/newStatus/companyAnnouncement'
                    })
                }
                if (type == 'notice'){
                    this.$router.push({
                        path:'/newStatus/jinKongAnnouncement'
                    })
                }
            }
        }
    }
</script>

<style lang="less" scoped>
    .home{
        width: 100%;
        height: 100%;
        font-size: 24px;
        .home_center{
            width: 100%;
            height: calc(100% - 62px);
            background: #F7F7F7;
            top: 62px;
            z-index: -1;
            .index_first_top{
                display: flex;
                justify-content: center;
                align-items: center;
                font-size: 18px;
                font-family: "Microsoft YaHei UI";
                font-weight: bold;
                color: #0D1944;
                .left{
                    width: 196px;
                    height: 1px;
                    background: url("./img/left.png") no-repeat;
                    background-size: contain;
                    margin-right: 29px;
                }
                .center{
                    font-family: "Microsoft YaHei";
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    .YINWEN{
                        font-size: 11px;
                        font-weight: 400;
                    }
                }
                .right{
                    width: 196px;
                    height: 1px;
                    background: url("./img/right.png") no-repeat;
                    background-size: contain;
                    margin-left: 29px;
                }
            }
            .index_top{
                width: 100%;
                height: 359px;
                overflow: hidden;
                .swiper{
                    height: 359px;
                    width: 100%;
                    background-size: contain;
                    position: relative;
                    .swiper-wrapper {
                        .swiper-slide {
                            width: 100%;
                            height: 100%;
                        }
                        img{
                            width: 100%;
                            height: 359px;
                        }
                       /* div:nth-child(1){
                            width: 100%;
                            height: 359px;
                            background: url("./img/ju2.png") no-repeat;
                            background-size: 100% 359px;
                        }
                        div:nth-child(2){
                            width: 100%;
                            height: 359px;
                            background: url("./img/ju1.png") no-repeat;
                            background-size: 100% 359px;
                        }*/
                    }
                    .swiper-button-prev{
                        /*left: 0px;*/
                        width: 80px;
                        height: 80px;
                        background: url("./img/zuo.png") no-repeat;
                        background-size: 80px 80px;
                        margin-left: 10px;
                        position: absolute;
                        top:179.5px;
                    }
                    .swiper-button-next{
                        width: 80px;
                        height: 80px;
                        background: url("./img/you.png") no-repeat;
                        background-size: 80px 80px;
                        margin-right: 10px;
                        position: absolute;
                        top:179.5px;
                    }
                }
                .content {
                    width: 100%;
                    height: 100%;
                    transition: 0.5s ease;
                    display: flex;
                    img {
                        width: 100%;
                        height: 389px;
                    }
                }
                .bottom {
                    position: absolute;
                    top: 75%;
                    display: inline-block;
                    transform: translateX(50%);
                    right: 50%;
                    span {
                        width: 14px;
                        height: 14px;
                        border-radius: 7px;
                        background-color: rgba(110, 102, 102, 0.849);
                        opacity: 0.4;
                        margin: 10px;
                        display: inline-block;
                        /* span是行内元素 */
                    }
                    /* 圆圈圈激活后*/
                    .active {
                        /*数值分别是：水平偏移，上下偏移，模糊，大小，颜色 */
                        box-shadow: 0px 0px 2px 2px #53a8ff;
                        background-color: #a0cfff !important;
                        opacity: 0.6;
                    }
                }
            }
            .index_first{
                width: 100%;
                padding: 26px 0;
                .index_first_bottom{
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    /*font-size: 11px;*/
                    margin-top: 29px;
                    .index_first_bottom_left{
                        width: 363px;
                        margin-right: 7px;
                        font-size: 10px;
                        .letter{
                            font-family: "Source Han Sans CN";
                            line-height: 28px;
                            font-weight: 400;
                            text-indent: 12px;
                            span{
                                font-size: 10px;
                                font-weight:bolder !important;
                            }
                        }
                    }
                    .index_first_bottom_right{
                        width: 307px;
                        height:289px;
                        background: url("./img/banner1.png") no-repeat;
                        background-size: 307px 289px;
                    }
                }
            }
            .index_sec{
                background: #ffffff;
                display: flex;
                align-items: center;
                justify-content: space-evenly;
                padding: 50px 200px;
                .index_sec_o{
                    font-size: 40px;
                    font-family: "Microsoft YaHei";
                    font-weight: bold;
                    color: #1E1E1E;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    .nian{
                        span{
                            font-size: 15px;
                            color: rgba(0,0,0,0.5);
                            font-weight: normal;
                        }
                    }
                    .line{
                        width: 39px;
                        height: 4px;
                        border-radius: 25px;
                        background: #3E83FE;
                        margin: 3px 0 8px;
                    }
                    .source{
                        font-size: 12px;
                        color: rgba(0,0,0,0.5);
                        font-weight: normal;
                        letter-spacing: 2px;
                    }
                }
                .index_sec_line{
                    width: 1px;
                    height: 69px;
                    border-right:rgba(238,238,238,1) 1px solid;
                }
            }
            .index_thi{
                padding: 26px 0;
                background: #F7F7F7;
                .index_thi_bottom{
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    font-size: 18px;
                    margin-top: 29px;
                    .index_thi_bottom_left{
                        width: 367px;
                        height:197px;
                        background: url("./img/banner2.png") no-repeat;
                        background-size: 367px 197px;
                    }
                    .index_thi_bottom_right{
                        margin-left: 15px;
                        .top{
                            font-family: "Microsoft YaHei UI Light";
                            font-weight: bold;
                            padding: 10px;
                            width: 274px;
                            height: 73px;
                            background: #ffffff;
                            border-bottom: 0.8px solid #3E83FE;
                            margin-bottom: 10px;
                            cursor: pointer;
                            .one{
                                font-size: 13px;
                                font-family: Source Han Sans CN;
                                font-weight: bolder;
                                color: #2C2C2C;
                            }
                            .two{
                                font-size: 11px;
                                font-family: Source Han Sans CN;
                                font-weight: 400;
                                color: #959595;
                                padding-top: 5px;
                            }
                            .two:hover{
                                color: #686262;
                            }
                            .three{
                                font-size: 11px;
                                font-family: Source Han Sans CN;
                                font-weight: 400;
                                color: #151515;
                                text-align: right;
                            }
                        }
                        .bottom{
                            margin-bottom: 0px !important;
                        }
                    }
                }
            }
            .index_four{
                padding: 44px 0 35px;
                background: #ffffff;
                .index_four_bottom{
                    width: 62%;
                    height: 345px;
                    background: url("./img/banner3.png") no-repeat;
                    background-size: contain;
                    margin: 28px auto 0;
                }
            }

        }
    }
</style>
